import { Routes } from '@/router';
import { ErrorEvent } from '@/services/analytics/events';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'CmgRewardsOffline',
})
export default class CmgRewardsOffline extends Vue {
  @Prop({ required: true, type: String })
  message!: string;

  get refreshImageUrl(): string {
    return this.$appStore.state.cms.images.icons.refresh.default;
  }

  get isOnPointsHistoryPage(): boolean {
    return this.$route.name === Routes.RewardsPointsHistory;
  }

  mounted() {
    this.$services.analytics.send(new ErrorEvent('account', `${this.isOnPointsHistoryPage ? '' : 'Huh, this is weird. '}${this.message}`, 'rewards-offline'));
  }

  onClickRefresh() {
    this.$emit('click');
    if (!this.isOnPointsHistoryPage) {
      this.$services.ui.setAppPepperVisibility(true);
      
      Promise.all([
        this.$services.loyalty.refreshPoints(true),
        this.$services.reward.getRewardOffers() 
      ])
      .then(() => this.$services.ui.setAppPepperVisibility(false))
      .catch(() => setTimeout(() => this.$services.ui.setAppPepperVisibility(false), 1000));
    }
  }
}